export const units = [
	{ short: 'y', long: 'year', seconds: 365 * 24 * 60 * 60 },
	{ short: 'm', long: 'month', seconds: 30 * 24 * 60 * 60 },
	{ short: 'd', long: 'day', seconds: 24 * 60 * 60 },
	{ short: 'h', long: 'hour', seconds: 60 * 60 },
	{ short: 'm', long: 'minute', seconds: 60 },
	{ short: 's', long: 'second', seconds: 1 },
];
export const defaultOptions = {
	label: 'short',
	keepZeroes: true,
};
export function getNumberText(unit, num, label) {
	if (label == 'short') {
		return `${num}${unit.short}`;
	}
	const maybeS = num === 1 ? '' : 's';
	return `${num} ${unit.long}${maybeS}`;
}
export function durationHumanFilter() {
	'ngInject';
	return (secondsFloat, givenOptions = {}) => {
		const options = Object.assign({}, defaultOptions, givenOptions);
		let secondsInt = Math.ceil(secondsFloat);
		let secondsLeft = secondsInt;
		let hasUnitsYet = false;
		const parts = [];
		units.forEach(unit => {
			if (secondsLeft >= unit.seconds) {
				let num = Math.floor(secondsLeft / unit.seconds);
				secondsLeft = secondsLeft % unit.seconds;
				hasUnitsYet = true;
				parts.push(getNumberText(unit, num, options.label));
			} else if (hasUnitsYet) {
				parts.push(getNumberText(unit, 0, options.label));
			}
		});
		let duration = parts.join(options.label == 'long' ? ', ' : ' ');
		if (!options.keepZeroes) {
			duration = duration.replace(/ 0\s*[a-z]+,?/g, '');
		}
		return duration;
	};
}
